import { useMemo } from 'react';
import {
  CampaignMapping,
  CampaignMappingSource,
} from 'src/api/campaignMappings';
import { DefaultCampaignCell } from '../../atoms/DefaultCampaignCell';
import { CampaignMappingDropdown, Option } from '../CampaignMappingDropdown';
import { useDisclosure } from '@chakra-ui/react';

type CampaignMappingCell = {
  row: CampaignMapping;
  column: string;
};

export const CampaignMappingCell: React.FC<CampaignMappingCell> = ({
  row,
  column,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const selectedOptions = useMemo<Option[]>(() => {
    return (row.sources ?? [])
      .filter((source: CampaignMappingSource) => source.source === column)
      .map((source) => ({
        label: source.campaign_name,
        value: source.id ?? source.source_campaign_id ?? source.campaign_name,
        source: source.source,
        table: source.table_name ?? '',
      }));
  }, [row.sources, column]);

  // this was done deliberately to avoid the AsyncSelect from being initalized for each cell
  // this hugely improves the performance of the grid
  // asyncSelect is initialized when user click on cell to open the dropdown, before the dropdown is opened, the AsyncSelect is not rendered
  return (
    <>
      {isOpen ? (
        <CampaignMappingDropdown
          campaignRow={row}
          column={column}
          isOpen={isOpen}
          onClose={onClose}
          value={selectedOptions}
        />
      ) : (
        <DefaultCampaignCell
          selectedCount={selectedOptions.length}
          onClick={onOpen}
        />
      )}
    </>
  );
};
